/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import axios from "axios";
import FetchError from "./FetchError";

const TIMEOUT = 45 * 1000; // 45 seconds

const API_URL = process.env.REACT_APP_API_URL;

const request = async (endpoint, options) => {
  try {
    const response = await axios(`${API_URL}/${endpoint}`, {
      TIMEOUT,
      ...options,
    });
    return response.data;
  } catch (error) {
    // normalise error messages
    if (error.response) {
      const { data } = error.response;
      const code = error.response.status;

      if (data.error) {
        throw new FetchError(data.error, code);
      }

      if (data.message) {
        throw new FetchError(data.error, code);
      }
      throw new FetchError(error, code);
    }

    throw new Error(error);
  }
};

export const get = (endpoint, options) =>
  request(endpoint, { method: "get", ...options });

export const post = (endpoint, options) =>
  request(endpoint, { method: "post", ...options });

export const put = (endpoint, options) =>
  request(endpoint, { method: "put", ...options });

export const remove = (endpoint) => request(endpoint, { method: "delete" });
